import { render } from "./UnknownActivity.vue?vue&type=template&id=275eb00d"
import script from "./UnknownActivity.vue?vue&type=script&lang=js"
export * from "./UnknownActivity.vue?vue&type=script&lang=js"
script.render = render

export default script